import * as React from 'react'

function getSnapshot() {
  return (
    typeof navigator !== 'undefined' &&
    'maxTouchPoints' in navigator &&
    navigator.maxTouchPoints > 0
  )
}

const subscribe = () => () => {}

export function useIsTouchDevice() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
